<template>
    <div id="OffersGeo" class="starter-template" :key="key">
        <div class="text-center">
            <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:fixed;top:50%;z-index:1001"></b-spinner>
        </div>

        <b-container>
            <b-row class="text-center" style="padding-top: 6px">
                <b-col>
                    <div class="text-center shad">
                        <h4 class="txtShad">{{ $t('OUTINGS') }}/{{ $t('TOURS') }}</h4>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <GeoChooser
           v-on:getGeoTo="getGeoTo"
           :keyTo="keyTo"
           ref="getGeoTo"
           v-bind:chooserName="whereToName"
           v-bind:scope=scopeTo
           v-bind:retOnce=false
        />
        <br>
        <b-container fluid>
            <b-row>

                <b-col>
                    <b-table class="backWhite descOuter"
                             id="listTableO"
                             responsive="sm"
                             selectable
                             :items="itemsO"
                             :fields="fieldsO"
                             :per-page=0
                             :current-page="curPageO"
                             striped
                             head-row-variant="info"
                             @row-selected="onRowSelectedO"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthO>10"
                                  v-model="curPageO"
                                  :total-rows="rowsO"
                                  :per-page="perPage"
                                  aria-controls="listTableO"
                                  pills
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid>
            <b-row v-if="geoType">
                <b-col>
                    <b-button :pressed.sync="filterToggle" @click="toBtm()">{{$t('FILTER')}}</b-button>
                    <b-button variant="success" class="m-2" v-if="filterToggle" @click="curPageO=1; getGeoOutings()">
                        {{ $t("SHOW")}}
                    </b-button>
                    <b-button v-show="filterToggle">
                                    <span  v-b-popover.hover.top="$t('CLEAR')"
                                           @click="swipe()"
                                    >
                                        <font-awesome-icon icon="broom" size="lg"/>
                                    </span>
                    </b-button>

                </b-col>
            </b-row>

            <b-row v-show="filterToggle">
                <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-row>
                            <b-col>
                                <b>{{$t('OUTING_TYPE')}} ({{$t('TOURA')}})</b>
                            </b-col>
                            <b-col cols="2">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                 <b-form-radio v-model="selType" :aria-describedby="ariaDescribedby" name="some-radios" value="group">{{$t('C_GROUP')}}</b-form-radio>
                                 <b-form-radio v-model="selType" :aria-describedby="ariaDescribedby" name="some-radios" value="individ">{{$t('C_INDIVID')}}</b-form-radio>
                                 <b-form-radio v-model="selType" :aria-describedby="ariaDescribedby" name="some-radios" value="unaided">{{$t('C_UNAID')}}</b-form-radio>
                            </b-col>

                            <b-col>
                                <b>{{$t('DUR')}}</b>
                                <b-form-radio v-model="selDur" :aria-describedby="ariaDescribedby" name="dur-radios" value="1">{{$t('DUR_O')}}</b-form-radio>
                                <b-form-radio v-model="selDur" :aria-describedby="ariaDescribedby" name="dur-radios" value="2">{{$t('DUR_T')}}</b-form-radio>
                            </b-col>
                        </b-row>

                            <br>
                        <b-form-checkbox-group
                                id="checkbox-group-1"
                                v-model="selWayType"
                                :options="optWayType"
                                :aria-describedby="ariaDescribedby"
                                name="flavour-1"
                        ></b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group v-slot="{ ariaDescribedby2 }">
                        <b-form-checkbox-group
                                id="checkbox-group-2"
                                v-model="selSubjType"
                                :options="optSubjType"
                                :aria-describedby="ariaDescribedby2"
                                name="flavour-2"
                        ></b-form-checkbox-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>

        <b-container fluid class="footer text-center">
            <b-row>
                <b-col v-if="curUserName=='admin'">
                    <b-form-checkbox-group>
                        <b-form-checkbox class="m-1" v-model="untieGeo" value="true">
                            <span  v-b-popover.hover.top="this.$t('UNTIE')">
                                <font-awesome-icon icon="unlink" size="lg"/>
                            </span>
                        </b-form-checkbox>
                        <b-button class="m-1">
                            <span  v-b-popover.hover.top="this.$t('DEL_GEO')" @click="$bvModal.show('modal-del')">
                                <font-awesome-icon icon="trash-alt" size="lg"/>
                            </span>
                        </b-button>
                    </b-form-checkbox-group>
                </b-col>
            </b-row>

        </b-container>

        <b-modal id="modal-del" ref="modal-del" no-close-on-backdrop>
            <template v-slot:modal-header>
                {{ $t("SURE")}}
                <b-button size="sm" @click="$bvModal.hide('modal-del')">
                    x
                </b-button>
            </template>

            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('modal-del')">
                    {{ $t("CANCEL")}}
                </b-button>
                <b-button variant="danger" @click="del()">
                    {{ $t("DELETE")}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-untie" ref="modal-untie" no-close-on-backdrop>
            <template v-slot:modal-header>
                {{ $t("SURE")}}
                <b-button size="sm" @click="$bvModal.hide('modal-untie')">
                    x
                </b-button>
            </template>

            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('modal-untie')">
                    {{ $t("CANCEL")}}
                </b-button>
                <b-button variant="danger" @click="untie()">
                    {{ $t("UNTIE")}}
                </b-button>
            </template>
        </b-modal>

        <div v-if="districtEn">
        <b-row class="text-center" v-if="filterToggle">
            <b-col>
                <h4 v-if="filterToggle">{{ $t("WHERE_FROM")}}</h4>
            </b-col>
        </b-row>

        <GeoChooser
            v-on:getGeoFrom="getGeoFrom"
            :keyFrom="keyFrom"
            v-if="filterToggle"
            ref="getGeoFrom"
            v-bind:chooserName="whereFromName"
            v-bind:scope="scopeFrom"
            v-bind:retOnce=false
        />
        </div>
        <div id="btm"></div>
        <br><br>

    </div>


</template>

<script>
import { BContainer, BRow, BCol, BButton, BTable, BPagination, BModal, BFormGroup, BSpinner,
    BFormCheckbox, BFormRadio, BFormCheckboxGroup } from 'bootstrap-vue';
import GeoChooser from "./GeoChooser.vue";

export default {
  name: 'OffersGeo',
  components: {
    GeoChooser,
    BContainer, BRow, BCol, BButton, BTable, BPagination, BModal, BFormGroup, BSpinner, BFormCheckbox, BFormRadio, BFormCheckboxGroup
  },
  data: function() {
    return {
        key: 0,
        keyTo: 0,
        keyFrom: 0,
        userName: '',
        curUserName: '',
        itemName: '',
        itemType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        ensembleRu: '',
        ensembleEn: '',
        sightRu: '',
        sightEn: '',
/*
        city: '',
        river: '',
        lake: '',
        mountain: '',
*/
        selCountryRu: '',
        selCountryEn: '',
        optCountryRu: [{}],
        optCountryEn: [{}],
        selDistrictRu: '',
        selDistrictEn: '',
        optDistrictRu: [{}],
        optDistrictEn: [{}],
        selCityRu: '',
        selCityEn: '',
        optCityRu: [{}],
        optCityEn: [{}],
        selEnsembleRu: '',
        selEnsembleEn: '',
        optEnsembleRu: [{}],
        optEnsembleEn: [{}],
        selSightRu: '',
        selSightEn: '',
        optSightRu: [{}],
        optSightEn: [{}],
        sure: null,
        refType: null,
        intLoc: this.$i18n.locale,
        item: '',
        perPage: 10,
        itemsO: [{}],
        selectedO: null,
        listLengthO: 1,
        curPageO: 1,
        geoType: '',
        chsnGeo: '',
        untieGeo: false,
        individ: 'false',
        unaided: 'false',
/*
        options: [
          { text: 'group', value: 'group' },
          { text: 'individ', value: 'individ' }
        ],
*/
        selType: 'group',
        selDur: '',
        fixOld: false,
        selWayType: [],
        optWayType: [
            { text: this.$t('OU_FOOT', this.intLoc), value: 'foot' },
            { text: this.$t('OU_CAR', this.intLoc), value: 'car' },
            { text: this.$t('OU_BUS', this.intLoc), value: 'bus' },
            { text: this.$t('OU_TRAM', this.intLoc), value: 'tram' },
            { text: this.$t('OU_TRAIN', this.intLoc), value: 'train' },
            { text: this.$t('OU_SHIP', this.intLoc), value: 'ship' },
            { text: this.$t('OU_PLANE', this.intLoc), value: 'plane' },
            { text: this.$t('OU_VELO', this.intLoc), value: 'velo' },
            { text: this.$t('OU_HRS', this.intLoc), value: 'horse' },
            { text: this.$t('OU_SKI', this.intLoc), value: 'ski' },
            { text: this.$t('OU_QUAD', this.intLoc), value: 'quad' },
            { text: this.$t('OU_SNOW', this.intLoc), value: 'snow' },
            { text: this.$t('OU_VRT', this.intLoc), value: 'virtual' }
        ],
        selSubjType: [],
        optSubjType: [
            { text: this.$t('C_INTRO', this.intLoc), value: 'intro' },
            { text: this.$t('C_CULTURE', this.intLoc), value: 'culture' },
            { text: this.$t('History', this.intLoc), value: 'history' },
            { text: this.$t('Architecture', this.intLoc), value: 'architect' },
            { text: this.$t('Religion', this.intLoc), value: 'religion' },
            { text: this.$t('C_WARFARE', this.intLoc), value: 'warfare' },
            { text: this.$t('C_INDUSTRY', this.intLoc), value: 'industry' },
            { text: this.$t('Science', this.intLoc), value: 'science' },
            { text: this.$t('Technique', this.intLoc), value: 'technique' },
            { text: this.$t('Craft', this.intLoc), value: 'craft' },
            { text: this.$t('C_SPORT', this.intLoc), value: 'sport' },
            { text: this.$t('C_HEALTH', this.intLoc), value: 'health' },
            { text: this.$t('C_NATURE', this.intLoc), value: 'nature' },
            { text: this.$t('Landfill', this.intLoc), value: 'rural' },
            { text: this.$t('C_TRANSPORT', this.intLoc), value: 'transport' },
            { text: this.$t('C_CHILDREN', this.intLoc), value: 'children' },
            { text: this.$t('C_PERSON', this.intLoc), value: 'person' },
            { text: this.$t('C_TASTING', this.intLoc), value: 'tasting' },
            { text: this.$t('C_MASTER', this.intLoc), value: 'masterc' },
            { text: this.$t('C_HUNT', this.intLoc), value: 'hunting' },
            { text: this.$t('C_FISH', this.intLoc), value: 'fishing' },
            { text: this.$t('C_SWIM', this.intLoc), value: 'swimming' },
            { text: this.$t('C_DIVE', this.intLoc), value: 'diving' },
            { text: this.$t('C_CLIMB', this.intLoc), value: 'climbing' },
            { text: this.$t('C_ETHNIC', this.intLoc), value: 'ethnicity' },
            { text: this.$t('C_QUEST', this.intLoc, this.intLoc), value: 'quest' }
        ],
        geoChooser: true,
        geoChooserF: false,
        filterToggle: false,
        startCountry: '',
        startDistrict: '',
        startCity: '',
        whereToName: 'whereTo',
        whereFromName: 'whereFrom',
        scopeTo: 'offers',
        scopeFrom: 'from',
        loading: false,
        title: '',
        metaDesc: '',
        //renderFrom: true,
        //showHand: false
    }
  },
  metaInfo() {
     return {
        title: `${this.title}`,
        meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
        ]
     }
 },
 beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    this.descMeta();
  },
  methods: {
    swipe() {
        this.selWayType=[];
        this.selSubjType=[];
        this.individ='false';
        this.selType='group';
        this.selDur='';
        this.startCountry = '';
        this.startDistrict = '';
        this.startCity = '';
        this.forceRender();
    },
    async forceRender() {
        this.filterToggle = false;
        await this.$nextTick();
        this.filterToggle = true;
    },
    async getGeoOutings() {
        //alert(this.startCountry + " " + this.geoType);
        if(!this.geoType) return;
        this.$bvModal.hide("modal-filter");
        let json = [];
        let j=0;
        for(let i=0; i<this.selWayType.length; i++) {
            if(this.selWayType[i]) {
                json[j] = this.selWayType[i];
                j++;
            }
        }
        for(let i=0; i<this.selSubjType.length; i++) {
            if(this.selSubjType[i]) {
                json[j] = this.selSubjType[i];
                j++;
            }
        }
        if(this.selType === 'individ') json[j] = 'individ';
        if(this.selType === 'unaided') json[j] = 'unaided';
        /*
        console.log(this.geoType,this.countryRu,this.countryEn,this.districtRu,this.districtEn,this.cityRu,this.cityEn,
            this.startCountry,this.startDistrict,this.startCity,this.intLoc,this.curPageO);
        */
        try {
            this.loading = true;
            //alert(this.geoType);
            const response = await this.$http.get('/getGeoOutings', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    startCountry: this.startCountry,
                    startDistrict: this.startDistrict,
                    startCity: this.startCity,
                    listLoc: this.intLoc,
                    pageNum: this.curPageO,
                    durDays: this.selDur,
                    featuresJSON: JSON.stringify(json)
                }
            });
            this.itemsO = response.data.itemList;
            this.listLengthO = response.data.listLen;
            if(this.listLengthO === 0) this.$showMsg(this.$t('NOT_FOUND'));
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
       finally {
            this.loading = false;
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPageT = 1;
        this.curPageP = 1;
        this.curPageO = 1;
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.selEnsembleRu = '';
        this.selEnsembleEn = '';
        this.selSightRu = '';
        this.selSightEn = '';
        this.itemsT = [];
        this.itemsP = [];
        this.itemsO = [];
    },
    onRowSelectedO(items) {
        this.item = items[0];
        this.itemType = 'o';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
        this.$router.push({
            path: '/Outing/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
        })
        }
    },
    toBtm() {
          var btm = document.getElementById('btm');
          btm.scrollIntoView();
    },
    clear() {
        this.geoType = '';
        this.selCountryRu = '';
        this.selCountryEn = '';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optCountryRu = [{}],
        this.optCountryEn = [{}],
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.optEnsembleRu = [{}],
        this.optEnsembleEn = [{}],
        this.optSightRu = [{}],
        this.optSightEn = [{}],
        this.itemsO = [{}];
        this.listLengthO = 0;
        this.startCountry = '';
        this.startDistrict = '';
        this.startCity = '';
        this.curPageO = 1;
        this.key++;
    },
    async untie() {
        this.$bvModal.hide('modal-untie');
        this.untieGeo = false;
        try {
            const response = await this.$http.get('/refDel', {
                params: {
                    userName: this.item.userName,
                    itemName: this.item.itemName,
                    itemType: this.itemType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    intLoc: this.intLoc
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    getGeoTo() {
        let chosenGeo = this.$refs.getGeoTo.getChosenGeo();
        //alert(chosenGeo.chooserName);
        if(chosenGeo.init) this.clear();
        if(!chosenGeo.countryEn) return;
        this.countryRu = chosenGeo.countryRu;
        this.countryEn = chosenGeo.countryEn;
        this.districtRu = chosenGeo.districtRu;
        this.districtEn = chosenGeo.districtEn;
        this.cityRu = chosenGeo.cityRu;
        this.cityEn = chosenGeo.cityEn;
        this.ensembleRu = chosenGeo.ensembleRu;
        this.ensembleEn = chosenGeo.ensembleEn;
        this.sightRu = chosenGeo.sightRu;
        this.sightEn = chosenGeo.sightEn;
        if(this.sightEn) this.geoType = 'sight';
        else if(this.ensembleEn) this.geoType = 'ensemble';
        else if(this.cityEn) this.geoType = 'city';
        else if(this.districtEn) this.geoType = 'district';
        else this.geoType = 'country';
        this.getGeoOutings();
        //this.myKey++;
    },
    getGeoFrom() {
        let chosenGeo = this.$refs.getGeoFrom.getChosenGeo();
        //alert(chosenGeo.chooserName);
        if(chosenGeo.init) this.clear();
        //if(!chosenGeo.countryEn) return;
        if(this.intLoc === 'ru') {
            this.startCountry = chosenGeo.countryRu;
            this.startDistrict = chosenGeo.districtRu;
            this.startCity = chosenGeo.cityRu;
        }
        else {
            this.startCountry = chosenGeo.countryEn;
            this.startDistrict = chosenGeo.districtEn;
            this.startCity = chosenGeo.cityEn;
        }
    },
    async del() {
        this.$bvModal.hide('modal-del');
        try {
            const response = await this.$http.get('/rmGeoItem', {
                params: {
                    refType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    ensembleRu: this.ensembleRu,
                    ensembleEn: this.ensembleEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Экскурсии и туры';
            this.metaDesc = 'Выбор экскурсий и туров по параметрам, странам и городам';
        }
        else {
            this.title = 'Excursions and tours'
            this.metaDesc = 'Choice of excursion and tours by parameters, countries and cities';
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
    },
    curPageO: function() {
        this.getGeoOutings();
    },
    countryEn: function() {
        this.curPageO=1;
        this.getGeoOutings();
    },
    districtEn: function() {
        if(!this.districtEn) return;
        this.curPageO=1;
        this.getGeoOutings();
    },
    cityEn: function() {
        if(!this.cityEn) return;
        this.curPageO=1;
        this.getGeoOutings();
    },
  },
  computed: {
    rowsO() {
        return this.listLengthO;
    },
    fieldsO() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'companyName', label: this.$t('ORG') },
        //{ key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    }

  }
}

</script>

<style>
</style>